// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*#region Blue*/
/*#endregion */
/*#region Blue-Grey*/
/*#endregion */
/*#region Red*/
/*#endregion */
/*#region Green*/
/*#endregion */
/*#region Yellow*/
/*#endregion*/
/*#region Misc*/
/*#endregion*/
/*#region Text*/
/*#endregion */
/*#region Elements*/
/**#region Event Container */
/*#endregion*/
/*#endregion */
/* #region Screen */
/* #endregion*/
.event-container {
  width: 360px;
  min-height: 170px;
  background: #24384a;
  border-radius: 5px;
  padding: 20px;
  margin-left: 15px;
  margin-top: 30px;
  display: inline-block;
  top: 45px;
  position: absolute;
  max-height: 80vh;
  overflow-y: auto;
}
@media (max-width: 859px) {
  .event-container {
    top: 180px;
    max-height: 50vh;
  }
}
@media (max-width: 599px) {
  .event-container {
    margin-left: 0;
    left: 50%;
    transform: translateX(-50%);
    top: 280px;
    max-height: 50vh;
  }
}

.event-list-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}
.event-list-header .header-left {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 4px;
}
.event-list-header h1 {
  margin: 0;
  padding: 0;
}
.event-list-header button {
  background-color: transparent;
  color: #52aaff;
  font-size: 12px;
}
.event-list-header .clear-text-btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 8px;
  margin-left: 2px;
}

.event-list-header.back-button-visible h1 {
  margin: 0 0 0 8px;
  padding: 0;
}

.event-log-list {
  list-style-type: disc;
  padding: 12px 20px 20px;
  max-height: 400px;
  overflow-y: auto;
}
.event-log-list::-webkit-scrollbar {
  width: 10px;
}
.event-log-list::-webkit-scrollbar-track {
  background: #24384a;
}
.event-log-list::-webkit-scrollbar-thumb {
  background: #15202b;
  border-radius: 10px;
}
.event-log-list li {
  margin-bottom: 14px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
